import {Box} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {withFieldGroup} from '../../../integrations/form/index.js'
import {countries} from '../../../utils/countries.js'
import {FormGrid} from '../../ui/form-grid.js'
import {FormSection} from '../form-section.js'
import {DEFAULT_ADDRESS} from './utils.js'
import {useRef} from 'react'

export const AddressFields = withFieldGroup({
  defaultValues: DEFAULT_ADDRESS,
  props: {} as {title?: string; description?: string; isRequired?: boolean},
  render: function Render({group, title, description, isRequired}) {
    const {t} = useTranslate('common')

    const initialCountry = useRef(
      countries.find(c => c.value === group.state.values.country || c.label === group.state.values.country)
    )

    return (
      <FormSection label={title} description={description}>
        <FormGrid repeatCount={4}>
          <Box gridColumn="span 2">
            <group.AppField name="addressLine">
              {field => (
                <field.TextField
                  size="sm"
                  type="text"
                  label={t('street')}
                  placeholder={t('street_placeholder')}
                  required={isRequired}
                />
              )}
            </group.AppField>
          </Box>

          <Box gridColumn="span 2">
            <group.AppField name="additionalInfo">
              {field => (
                <field.TextField
                  size="sm"
                  type="text"
                  label={t('additional_info')}
                  placeholder={t('additional_info_placeholder')}
                />
              )}
            </group.AppField>
          </Box>

          <group.AppField name="city">
            {field => (
              <field.TextField
                size="sm"
                type="text"
                label={t('city')}
                placeholder={t('city_placeholder')}
                required={isRequired}
              />
            )}
          </group.AppField>

          <group.AppField name="postalCode">
            {field => (
              <field.TextField
                size="sm"
                type="text"
                label={t('postal_code')}
                placeholder={t('postal_code_placeholder')}
                required={isRequired}
              />
            )}
          </group.AppField>

          <group.AppField name="region">
            {field => <field.TextField size="sm" type="text" label={t('state')} placeholder={t('state_placeholder')} />}
          </group.AppField>

          <group.AppField name="country" mode="value">
            {field => {
              // legacy rows may hold a country name (e.g. "Romania") instead of an
              // ISO alpha-2 code, so surface the saved value as an extra option
              const savedCountry = field.state.value
              const isKnownCode = countries.some(country => country.value === savedCountry)
              const countryItems =
                savedCountry && !isKnownCode ? [...countries, {label: savedCountry, value: savedCountry}] : countries

              return (
                <field.Combobox
                  size="sm"
                  label={t('country')}
                  placeholder={
                    initialCountry.current ? t('eg', {value: initialCountry.current.label}) : t('your_country')
                  }
                  items={countryItems}
                  required={isRequired}
                  autoComplete="address-country"
                />
              )
            }}
          </group.AppField>
        </FormGrid>
      </FormSection>
    )
  },
})
